const typefaces = {
  default: "'Montserrat'",
} as const;

export type Typeface = keyof typeof typefaces;

export default typefaces;
